import {Fab, FabProps} from "@mui/material";
import {useEffect, useState} from "react";


/* MUST NOT USE style={{}}. 				SX={{}} SHOULD BE USED FOR POSITIONING. */
export function APXHideOnScrollFab({icon, scrollThreshold = 24, backgroundColour, colour, ...props}:
														 { icon: JSX.Element, scrollThreshold?: number, backgroundColour: string, colour: string }
														 & FabProps) {
	  
	  const [visible, setVisible] = useState(true);
	  
	  const handleScroll = () => {
			 if (window.scrollY > scrollThreshold) {
					setVisible(false);
			 } else {
					setVisible(true);
			 }
	  };
	  
	  useEffect(() => {
			 window.addEventListener("scroll", handleScroll);
			 return () => {
					window.removeEventListener("scroll", handleScroll);
			 };
	  }, [scrollThreshold]);
	  
	  return (
				 <>
						<Fab style={{
							  transition: "transform 0.25s ease-in-out", transform: visible ? "scale(1)" : "scale(0)",
							  backgroundColor: backgroundColour,
							  color: colour
						}}
							  {...props}
						>
							  {icon}
						</Fab>
				 </>
	  );
}